module.exports = __webpack_public_path__ + "mobile/img/icon_qrcode_bg.80afc50e.png";